/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Failed_To_Mark_ShippedInputs */

const en_samples_failed_to_mark_shipped = /** @type {(inputs: Samples_Failed_To_Mark_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to mark selected samples as shipped`)
};

const es_samples_failed_to_mark_shipped = /** @type {(inputs: Samples_Failed_To_Mark_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al marcar las muestras seleccionadas como enviadas`)
};

/**
* | output |
* | --- |
* | "Failed to mark selected samples as shipped" |
*
* @param {Samples_Failed_To_Mark_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_failed_to_mark_shipped = /** @type {((inputs?: Samples_Failed_To_Mark_ShippedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Failed_To_Mark_ShippedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_failed_to_mark_shipped(inputs)
	return es_samples_failed_to_mark_shipped(inputs)
});